import React from "react";

import styles from "components/BudgetBuilder/Overview/OverviewLineItemsList/styles.css";
import { useTenantFormatter } from "components/BudgetBuilder/shared/TenantFormatter";
import Table from "components/Table";
import { getCostShareSubtotal } from "utils/budgetBuilder";

const OverviewInternalCostShareRow = ({ categoryTextByValue, items }) => {
	const { currencyFormatter } = useTenantFormatter();

	return (
		<Table.Row>
			<Table.Cell className={styles.cellAlignLeft}>
				<span>{categoryTextByValue?.[items[0].value]}</span>
			</Table.Cell>
			{items.map((item, p) => (
				<Table.Cell key={`period-${p}`}>
					<div className={styles.cellAlignRight}>
						<span>{currencyFormatter(item.costShareAmount, 0)}</span>
					</div>
				</Table.Cell>
			))}
			<Table.Cell className={styles.cellAlignRight}>
				<span className={styles.bold}>
					{currencyFormatter(getCostShareSubtotal(items))}
				</span>
			</Table.Cell>
		</Table.Row>
	);
};

export default OverviewInternalCostShareRow;
